<div class="c-card">
	<div class="c-content u-no-p@up-to-md">
		<table-insurance-policies [(insurancePolicies)]="vm.insurancePolicies" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-insurance-policies>
	</div>
	<div *ngIf="vm.insurancePolicies && vm.insurancePolicies?.length > vm.pageSize">	
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.insurancePolicies?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
